// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-Experience-cat__reply-submittion[data-v-2fb2df64]{background-color:#f4f4f4;padding:1.45em;border-top:1px solid #dadada}.c-Experience__reply--nested[data-v-2fb2df64]{border:1px solid #dadada;margin-top:1.5em}\n", ""]);
// Exports
module.exports = exports;
